import {
  LOGIN, ON_REFRESH, PLAY_REQUEST, PLAY, PLAY_DONE_CHECK, SET_PLAYING, SET_MUTE, UPDATE_BET, UPDATE_SIDE_BET, UPDATE_STATS,
  UPDATE_WIN, ERROR, SHOW_MESSAGE, RESET_REALITYCHECK, GO_TO_LOBBY, TOGGLE_MUTE, TOGGLE_SETTINGS_OPEN,
  SET_SETTINGSSCREEN, SET_SKIPFEATURE, BLOCKED_SKIPFEATURE, SET_RESTORESTATE, SET_FORCE_UPDATE, SET_PAUSED,
  TOGGLE_SPACE_TO_SPIN, ATTEMPT_TO_SPIN, SET_SAVEDSETTINGS, UPDATE_JACKPOT, SET_QUICKSPIN,
  SET_ORIENTATION_CHECKED, SET_FREEROUNDS_LEFT, SET_PLAYING_REQUEST, FUN_MONEY_LOGIN, ERROR_CLOSED,
  JACKPOT_MESSAGE_CLOSED, SET_HASSPLASH, ON_SPLASHSTART, SET_HIDE_SPLASH, SET_HASINTRO, SET_HIDE_INTRO, SET_INTRO_LOADED,
  LOAD_ASSETS, TOGGLE_SFX, TOGGLE_MUSIC, SET_MUTE_MUSIC, SET_MUTE_SFX, RESTORE_SETTINGS, TOGGLE_SETTING,
  SET_SOUND_AVAILABLE, SET_CHEAT, SET_CHEATS, SET_DEMO, SET_DEMO_INDEX, SET_GAMESPEED, SET_NOFULLSCREEN,
  LOAD_SOUNDS, SOUNDS_LOADED, SET_STEP_DEBUG, SET_ALLOW_SPIN_REQUESTS, SET_INFOCUS, RERUN_LAST_ROUND,
  DISABLE_RESTORESTATE, TOGGLE_HOTZONE, SET_FALLBACK_RESPONSE, MAKE_FREEROUND_CHOICE, DISPLAY_FREEROUND,
  READY_FOR_PLAY_DONE, TOGGLE_FPSMETER, CURRENCY_CHANGED, SET_FREEROUNDS_BET, SET_SIDE_GAMES,
  TOGGLE_RECORDING_CONTROLS, TOGGLE_CONFIGURABLE_VARIABLES, SET_MENU_OPACITY, TOGGLE_POPUP_TRIGGERER,
  TRIGGER_DEBUG_POPUP, ON_START_RESTORE, DISPLAY_HISTORY, CLOSE_GAMEROUND,

  // POSTMESSAGE
  SET_EXTERNAL_PAUSE, SET_EXTERNAL_PAUSE_REQUEST,
  GameEvents, GAME_WAS_PAUSED,
} from '../constants'
import config from 'config'

/**
 * Action called upon login, to forward game data.
 * @param {object} data - Object containing possible configurations
 * and other round data.
 * @returns {{type: string, config: *, response: *}}
 */
export function onRefresh(data) {
  const { config, refresh, stats } = data
  return {
    type: ON_REFRESH,
    config,
    response: { ...refresh, stats }
  }
}

/**
 * Action which sends the game client a request to play, which
 * the client will then act on, if it is in a ready to play state.
 * @param {object} params - Parameters for the spin request (e.g. game action "spin").
 */
export function playRequest(params) {
  return {
    type: PLAY_REQUEST,
    params
  }
}

/**
 * Action that forces the game playing status.
 * @param {boolean} playing - If the game is in a playing state or not.
 * @returns {{type: string, playing: *}}
 */
export function setPlaying(playing) {
  return {
    type: SET_PLAYING,
    playing
  }
}

/**
 * "Send a request to the game to enable the UI when error 400 or 404 occurs.
 * Game should decide if it's in a state where it is still playing."
 * @deprecated - Action created before mc_full-slot_ui was created.
 * @param {boolean} shouldPlay - The new state.
 * @returns {{type: string, shouldPlay: *}}
 */
export function setPlayingRequest(shouldPlay) {
  return {
    type: SET_PLAYING_REQUEST,
    shouldPlay
  }
}

/**
 * Action called by the game client, when it's ready to spin (follow up on playRequest).
 * Sends a play request to the backend.
 * @param {object} _params -
 * @returns {{type: string, params: {timestamp: number}}}
 */
export function play(_params) {
  const params = { ..._params, timestamp: Date.now() }
  return {
    type: PLAY,
    params
  }
}

/**
 * Action that propagates the PLAY_DONE_CHECK event.
 * Called upon by the game client after a round has finished.
 * @returns {{type: string}}
 */
export function playDone() {
  return {
    type: PLAY_DONE_CHECK
  }
}

/**
 * Action called after locales have loaded, to initiate the login process.
 * @returns {{type: string}}
 */
export function login() {
  return {
    type: LOGIN,
  }
}

/**
 * Action called after locales have loaded, to initiate fun money login process.
 * @returns {{type: string}}
 */
export function funMoneyLogin(prototypeStats = undefined) {
  return {
    type: FUN_MONEY_LOGIN,
    prototypeStats
  }
}

/**
 * Action called to force the bet size (e.g. during free rounds).
 * @param {number} size - The bet size which the client should be forced to use.
 * @returns {{type: string, forced: *}}
 */
export function forceBet(size) {
  return {
    type: UPDATE_BET,
    forced: size
  }
}

/**
 * Action called to increase the bet size level by one.
 * @returns {{type: string, change: number}}
 */
export function increaseBet() {
  return {
    type: UPDATE_BET,
    change: 1
  }
}

/**
 * Action called to decrease the bet size level by one.
 * @returns {{type: string, change: number}}
 */
export function decreaseBet() {
  return {
    type: UPDATE_BET,
    change: -1
  }
}

/**
 * Action called to update the current bet size.
 * @param {number} bet - The new bet value.
 * @param {boolean} forced - If the new bet is forced or not.
 * @returns {{type: string, bet: *, forced: *}}
 */
export function setBet(bet, forced) {
  return {
    type: UPDATE_BET,
    bet,
    forced
  }
}

/**
 * Action called to update the current side bet size.
 * @param {number} bet - The new bet value.
 * @param {string} sideGameName - The side game name.
 * @returns {{type: string, bet: *, sideGameName: string}}
 */
export function setSideBet(bet, sideGameName) {
  return {
    type: UPDATE_SIDE_BET,
    bet,
    sideGameName
  }
}

/**
 * Action called to update the win value on the UI.
 * @param {number} win - The new win value.
 * @returns {{type: string, win: *}}
 */
export function setWin(win, dropWinCount) {
  return {
    type: UPDATE_WIN,
    win,
    dropWinCount
  }
}

/**
 * Action called to update the UI using the `stats` object
 * @param stats
 * @returns {{type: string, stats: *}}
 */
export function updateStats(stats) {
  return {
    type: UPDATE_STATS,
    stats
  }
}

/**
 * Action called to reset the reality check timer on the backend.
 * @returns {{type: string}}
 */
export function resetRealityCheck() {
  return {
    type: RESET_REALITYCHECK
  }
}

/**
 * Action called to display an error popup.
 * @param {object} err - The error payload.
 * @returns {{type: string, error: *}}
 */
export function error(err) {
  return {
    type: ERROR,
    error: err
  }
}

/**
 * Action called to display a normal message popup in the UI.
 * @param {object} mess - The message payload.
 * @returns {{type: string, message: *}}
 */
export function message(mess) {
  return {
    type: SHOW_MESSAGE,
    message: mess
  }
}

/**
 * Action called to redirect the player to the homeurl.
 * @returns {{type: string}}
 */
export function goToLobby() {
  return {
    type: GO_TO_LOBBY
  }
}

/**
 * Action called to mute/unmute all the game sounds.
 * @param {boolean} mute - Whether the sounds should be muted or not.
 * @returns {{type: string, mute: *}}
 */
export function setMute(mute) {
  return {
    type: SET_MUTE,
    mute
  }
}

/**
 * Action called when the sound button is clicked.
 * @returns {{type: string}}
 */
export function toggleMute(muted) {
  return {
    type: TOGGLE_MUTE,
    muted
  }
}

/**
 * Action called to set the mute status of game SFX.
 * @param {boolean} mute - The new mute state.
 * @returns {{type: string, mute: *}}
 */
export function setMuteSFX(mute) {
  return {
    type: SET_MUTE_SFX,
    mute
  }
}

/**
 * Action called when the mute SFX toggle is pressed.
 * @returns {{type: string}}
 */
export function toggleMuteSFX() {
  return {
    type: TOGGLE_SFX
  }
}

/**
 * Action called to set the mute status of game music.
 * @param {boolean} mute - The new mute state.
 * @returns {{type: string, mute: *}}
 */
export function setMuteMusic(mute) {
  return {
    type: SET_MUTE_MUSIC,
    mute
  }
}

/**
 * Action called when the mute music toggle is pressed.
 * @returns {{type: string}}
 */
export function toggleMuteMusic() {
  return {
    type: TOGGLE_MUSIC
  }
}

/**
 * Action called to toggle the Space to Spin feature on or off.
 * @returns {{type: string}}
 */
export function toggleSpaceToSpin() {
  return {
    type: TOGGLE_SPACE_TO_SPIN
  }
}

/**
 * @deprecated attemptToSpin is never called.
 * @returns {{type: string}}
 */
export function attemptToSpin() {
  return {
    type: ATTEMPT_TO_SPIN
  }
}

/**
 * Action called to toggle the settings overlay on or off.
 * @returns {{type: string}}
 */
export function toggleSettings() {
  return {
    type: TOGGLE_SETTINGS_OPEN
  }
}

/**
 * Action called to toggle a single setting on or off.
 * @param {string} setting - The name of the setting that should be toggled.
 * @returns {{type: string, setting: *}}
 */
export function toggleSingleSetting(setting) {
  return {
    type: TOGGLE_SETTING,
    setting
  }
}

/**
 * Action called to open the settings screen, in a specific sub-category (e.g. autoplay)
 * @param {string} screen - The name of the sub-category, which should be opened.
 * @returns {{type: string, screen: *}}
 */
export function openSettingsScreen(screen) {
  return {
    type: SET_SETTINGSSCREEN,
    screen
  }
}

/**
 * Action called to set the state of the skipfeature.
 * @param {boolean} skipfeature - The new state of the skipfeature.
 * @returns {{type: string, skipfeature: *}}
 */
export function setSkipFeature(skipfeature) {
  return {
    type: config.disableSkipFeature ? BLOCKED_SKIPFEATURE : SET_SKIPFEATURE,
    skipfeature
  }
}

/**
 * Was used to force the UI to update.
 * @deprecated - Does not seem to be used anymore.
 * @param forceUpdate
 * @returns {{type: string, forceUpdate: *}}
 */
export function setForceUpdate(forceUpdate) {
  return {
    type: SET_FORCE_UPDATE,
    forceUpdate
  }
}

/**
 * Action called to send a restoreState to the backend.
 * @param {object|string} restoreState - Object or string, containing restoreState information.
 * @returns {{type: string, restoreState: *}}
 */
export function setRestoreState(restoreState) {
  return {
    type: SET_RESTORESTATE,
    restoreState
  }
}

/**
 * Action called to send the current saved settings, to the server.
 * @returns {{type: string}}
 */
export function setSavedSettings() {
  return {
    type: SET_SAVEDSETTINGS
  }
}

/**
 * Action called to set the current status of settings to the status from the saved settings.
 * @param settings
 * @returns {{type: string, settings: *}}
 */
export function restoreSettings(settings) {
  return {
    type: RESTORE_SETTINGS,
    settings
  }
}

/**
 * Action to tell the game that it should enable splash functionality.
 * @param {boolean} hasSplash - If the splashscreen is available
 */
export function setHasSplash(hasSplash) {
  return {
    type: SET_HASSPLASH,
    hasSplash
  }
}

/**
 * Reports that the splash-screen is starting to show
 */
export function onSplashStart() {
  return {
    type: ON_SPLASHSTART
  }
}
/**
 * Hides the splash-screen
 */
export function hideSplash() {
  return {
    type: SET_HIDE_SPLASH,
    hideSplash: true
  }
}

/**
 * Action to tell the game that it should enable intro-movie functionality.
 * @param {boolean} hasIntro - If the intro-movie is available
 */
export function setHasIntro(hasIntro) {
  return {
    type: SET_HASINTRO,
    hasIntro
  }
}


/**
 * Hides the intro-movie
 */
export function hideIntro() {
  return {
    type: SET_HIDE_INTRO,
    hideIntro: true
  }
}

/**
 * Hides the intro-movie
 */
export function setIntroLoaded(introLoaded) {
  return {
    type: SET_INTRO_LOADED,
    introLoaded
  }
}

/**
 * Action to update the internal logic to set if it shouold try to enter fullscreen or not.
 * @param {boolean} noFullscreen - If the game should request going to fullscreen.
 */
export function setNoFullscreen(noFullscreen) {
  return {
    type: SET_NOFULLSCREEN,
    noFullscreen
  }
}


/**
 * Action to set the current pause state of the game.
 * @param {boolean} paused - The new pause state.
 * @returns {{type: string, paused: *}}
 */
export function setPaused(paused) {
  return {
    type: SET_PAUSED,
    paused
  }
}

/**
 * Action to set if the fullscreen has been checked on
 * the current orientation or not.
 * @param checked
 * @returns {{type: string, checked: *}}
 */
export function setOrientationChecked(checked) {
  return {
    type: SET_ORIENTATION_CHECKED,
    checked
  }
}

/**
 * Action to update the current free rounds remaining.
 * @param {number} spins - The amount of free rounds remaining.
 * @returns {{type: string, spins: *}}
 */
export function setFreeroundsLeft(spins) {
  return {
    type: SET_FREEROUNDS_LEFT,
    spins
  }
}

/**
 * Action called to load the list of assets.
 * @param {object} Assets - List of assets and their information.
 * @returns {{type: string, Assets: *}}
 */
export function loadAssets(Assets) {
  return {
    type: LOAD_ASSETS,
    Assets
  }
}

/**
 * Action called to store the provided cheats.
 * @param {object} cheats - Object with cheats.
 * @returns {{type: string, cheats: *}}
 */
export function setCheats(cheats) {
  return {
    type: SET_CHEATS,
    cheats
  }
}

/**
 * Action called to store the provided demo cheats.
 * @param {Array<object>} demo - Array with cheats.
 * @returns {{type: string, demo: *}}
 */
export function setDemo(demo) {
  return {
    type: SET_DEMO,
    demo
  }
}

/**
 * Action called to set the demo index
 * @param {number} index
 * @returns {{type: string, index: number}}
 */
export function setDemoIndex(index) {
  return {
    type: SET_DEMO_INDEX,
    index
  }
}

/**
 * Action called to store the provided gamespeed.
 * @param {number} gamespeed
 * @returns {{type: string, gamespeed: number}}
 */
export function setGamespeed(gamespeed) {
  return {
    type: SET_GAMESPEED,
    gamespeed
  }
}

/**
 * Action called to store the provided menuOpacity.
 * @param {number} menuOpacity
 * @returns {{type: string, menuOpacity: number}}
 */
export function setMenuOpacity(menuOpacity) {
  return {
    type: SET_MENU_OPACITY,
    menuOpacity
  }
}

/**
 * Action called upon closing of an error.
 * @param {number] _error - The errorCode of the closed error.
 * @returns {{type: string, error: *}}
 */
export function errorClosed(_error) {
  return {
    type: ERROR_CLOSED,
    error: _error
  }
}

/**
 * Action called when a jackpot message is closed, letting the client
 * know what amount was displayed.
 * @param {number} newJackpot - The size of the jackpot.
 */
export function jackpotMessageClosed(newJackpot) {
  return {
    type: JACKPOT_MESSAGE_CLOSED,
    newJackpot,
  }
}

/**
 * Action called to update the current jackpot.
 * @param {object} newJackpot - Object containing data about the new jackpot.
 * @returns {{type: string, newJackpot: *}}
 */
export function updateJackpot(newJackpot) {
  return {
    type: UPDATE_JACKPOT,
    newJackpot,
  }
}

/**
 * Action called to set the status if sounds are available for loading or not.
 * @param {boolean} soundAvailable - The state if sounds should be available or not.
 * @returns {{type: string, soundAvailable: *}}
 */
export function setSoundAvailable(soundAvailable) {
  return {
    type: SET_SOUND_AVAILABLE,
    soundAvailable
  }
}

/**
 * Action called to start the loading of the sound assets.
 * @returns {{type: string}}
 */
export function loadSounds() {
  return {
    type: LOAD_SOUNDS
  }
}

/**
 * Action called after sounds have been loaded.
 * Propagates the SOUNDS_LOADED event.
 * @returns {{type: string}}
 */
export function soundsLoaded() {
  return {
    type: SOUNDS_LOADED
  }
}

/**
 * Action called to set the state of the step debug feature.
 * @param {boolean} stepDebug - The new state of the step debug feature.
 * @returns {{type: string, stepDebug: *}}
 */
export function setStepDebug(stepDebug) {
  return {
    type: SET_STEP_DEBUG,
    stepDebug
  }
}

/**
 * Action called to set the state of the quick spin feature.
 * @param {boolean} quickSpin - The new state of the quick spin feature.
 * @returns {{type: string, quickSpin: *}}
 */
export function setQuickSpin(quickSpin) {
  return {
    type: SET_QUICKSPIN,
    quickSpin
  }
}

/**
 * Action called to set the state of allowSpinRequests.
 * This is to prevent users from being able to spin, before the game
 * has actually finished loading.
 * @param {boolean} allowSpinRequests - The new state of allowSpinRequests.
 * @returns {{type: string, allowSpinRequests: *}}
 */
export function setAllowSpinRequests(allowSpinRequests) {
  return {
    type: SET_ALLOW_SPIN_REQUESTS,
    allowSpinRequests
  }
}

/**
 * Action called when the client switches focus.
 * Sets the state if the client is in focus or not.
 * @param {boolean} inFocus - The new state of inFocus.
 * @returns {{type: string, inFocus: *}}
 */
export function setInFocus(inFocus) {
  return {
    type: SET_INFOCUS,
    inFocus
  }
}

/**
 * Action called to re-run the previous round.
 * @returns {{type: string}}
 */
export function reRunLastRound() {
  return {
    type: RERUN_LAST_ROUND
  }
}

/**
 * Action called to set the state of disableRestoreState.
 * @param {boolean} disable - The new state of the disableRestoreState.
 * @returns {{type: string, disable: *}}
 */
export function disableRestoreState(disable) {
  return {
    type: DISABLE_RESTORESTATE,
    disable
  }
}

/**
 * Action called to toggle a specific hotzone, using the DevTools.
 * @param {string} hotzone - The name of the hotzone to be toggled.
 * @returns {{type: string, hotzone: *}}
 */
export function toggleHotzone(hotzone) {
  return {
    type: TOGGLE_HOTZONE,
    hotzone
  }
}

/**
 * Action called to toggle the FPS meter on or off, using the DevTools.
 * @returns {{type: string }}
 */
export function toggleFPSmeter() {
  return {
    type: TOGGLE_FPSMETER
  }
}

/**
 * Action called to toggle the Recording tools on or off, using the Devtools.
 */
export function toggleRecordingControls() {
  return {
    type: TOGGLE_RECORDING_CONTROLS,
  }
}

/**
 * Action called to toggle the Popup Debugger on or off, using the Devtools.
 */
export function toggleConfigurableVariables() {
  return {
    type: TOGGLE_CONFIGURABLE_VARIABLES
  }
}

/**
 * Action called to toggle the Popup Triggerer tool on or off, using the Devtools.
 */
export function togglePopupTriggerer() {
  return {
    type: TOGGLE_POPUP_TRIGGERER,
  }
}

/**
 * Action called to manually trigger a popup, using the Popup triggerer.
 */
export function triggerDebugPopup(args) {
  return {
    type: TRIGGER_DEBUG_POPUP,
    args
  }
}

/**
 * Action called to set the cheat to be used on next spin.
 * @param {string} cheat - A JSON in string format, containing the cheat.
 * @returns {{type: string, cheat: *}}
 */
export function setCheat(cheat) {
  return {
    type: SET_CHEAT,
    cheat
  }
}

/**
 * Action called to store a valid fallback response.
 * @param {object} fallbackResponse - An object containing round information.
 * @returns {{type: *, fallbackResponse: *}}
 */
export function setFallbackResponse(fallbackResponse) {
  return {
    type: SET_FALLBACK_RESPONSE,
    fallbackResponse
  }
}

/**
 * Action called to dispatch READY_FOR_PLAY_DONE event when the framework
 * is ready for the next round.
 * @returns {{type: string}}
 */
export function readyForPlayDone() {
  return {
    type: READY_FOR_PLAY_DONE,
  }
}

/**
 * Action called to send a skip/delete freeround choice to the server.
 * @param {string} choice - Either "skip" or "delete"
 * @returns {{type: string, choice: *}}
 */
export function makeFreeRoundChoice(choice) {
  return {
    type: MAKE_FREEROUND_CHOICE,
    choice
  }
}

export function displayFreeround(display, isTournament) {
  return {
    type: DISPLAY_FREEROUND,
    display,
    isTournament
  }
}

/**
 * Action called when the currency has changed.
 * @param {string} currency - The currency string (e.g. EUR, GBP)"
 * @param {string} currencySign - The currencySign to represent the current currency (e.g. €, £).
 * @returns {{type: string}}
 */
export function currencyChanged(currency, currencySign) {
  return {
    type: CURRENCY_CHANGED,
    currency,
    currencySign
  }
}

export function setFreeroundsBet(freeroundsBet, freeroundsBetLines) {
  return {
    type: SET_FREEROUNDS_BET,
    freeroundsBet,
    freeroundsBetLines,
  }
}

/**
 * Action called when there is an external pause request.
 * @param {Boolean} externalPauseRequest - Pause (true) / Resume (false).
 * @param {string} id - (Optional) id to be returned when the game is resumed.
 * @param {Boolean} externalRC - (Optional) Boolean if an external RC is to be displayed when the game gets paused.
 */
export function setExternalPauseRequest(externalPauseRequest, id, externalRC) {
  return {
    type: SET_EXTERNAL_PAUSE_REQUEST,
    externalPauseRequest,
    id,
    externalRC,
  }
}

/**
 * Action called when a game should be paused due to external influence.
 * @param {Boolean} externalPause - Boolean flag if game should be paused or not.
 */
export function setExternalPause(externalPause) {
  return {
    type: SET_EXTERNAL_PAUSE,
    externalPause
  }
}

/**
 * Action called when the game was paused at the end of a round.
 * @param {String} incoming - String containing the incoming message.
 */
export function gameWasPaused(incoming) {
  return {
    type: GAME_WAS_PAUSED,
    message: {
      ...incoming
    }
  }
}

/**
 * Action called when startRestore flow is initiated.
 */
export function onStartRestore() {
  return {
    type: ON_START_RESTORE,
  }
}

/**
 * Action called to display the rc-history
 */
export function displayHistory() {
  return {
    type: DISPLAY_HISTORY
  }
}


export function closeGameRound() {
  return {
    type: CLOSE_GAMEROUND
  }
}

/* ------- GAME EVENTS ------- */
/**
 * Event to be called when a round has started.
 * @param {Number} betAmount - A value in cents
 */
export function GE_RoundStarted(betAmount) {
  return {
    type: GameEvents.ROUND_STARTED,
    betAmount
  }
}

/**
 * Event to be called when the game round has finished.
 */
export function GE_RoundEnded() {
  return {
    type: GameEvents.ROUND_ENDED
  }
}

/**
 * Event to be called once a bonus round has started, this can differ from game to game.
 * Some might have a pick mode, some respins or something else.
 * @param {Object} params - Object containing information about the bonus round.
 * Expects at least a type, e.g. { type: 'respin' }
 */
export function GE_BonusStarted(params) {
  return {
    type: GameEvents.BONUS_STARTED,
    params
  }
}

/**
 * Similar to GE_BonusStarted, but when the bonus has ended.
 * @param {Object} params - Object containing information about the bonus round.
 * Expects at least a type, e.g. { type: 'respin' }
 */
export function GE_BonusEnded(params) {
  return {
    type: GameEvents.BONUS_ENDED,
    params
  }
}

/**
 * Event called when the game starts the freespins.
 * @param {Number} params - Number of spins that you begin the freespins with.
 */
export function GE_FreespinStarted(params) {
  return {
    type: GameEvents.FREE_SPINS_STARTED,
    params
  }
}

/**
 * Event called when the freespins are over.
 * @param {Number} params - Total number of spins that the user had in the end.
 * This number can differ from the starting value.
 */
export function GE_FreespinEnded(params) {
  return {
    type: GameEvents.FREE_SPINS_ENDED,
    params
  }
}

/**
 * Event called when the win amount is being presented (e.g end of each spin/respin/freespin).
 * @param {Number} params - The total win (in cents) that is going to be displayed.
 */
export function GE_WinPresentationStarted(params) {
  return {
    type: GameEvents.WIN_PRESENTATION_STARTED,
    params
  }
}

/**
 * Event called once the complete win amount has been presented to the player.
 * @param {Number} params - The total win that was displayed, same value as in the GE_WinPresentationStarted.
 */
export function GE_WinPresentationEnded(params) {
  return {
    type: GameEvents.WIN_PRESENTATION_ENDED,
    params
  }
}

export function jackpotEventStarted() {
  return {
    type: GameEvents.JACKPOT_EVENT_STARTED
  }
}

export function jackpotEventEnded() {
  return {
    type: GameEvents.JACKPOT_EVENT_ENDED
  }
}
